import React from "react";
import '../../../App.scss';
import backgroundImage from "../../../assets/images/main_background.png";
import Grid from "@material-ui/core/Grid";
import Toolbar from "../../Toolbar";
import League from "../../pageComponents/WinnersTable/League";
import PicoLoader from "../../pageComponents/Common/PicoLoader";
import Virus from "../../../assets/images/group_3309.png";
import Holder from "../../../assets/images/img_choob.png";
import {withRouter} from "react-router-dom";
import axios from "axios";
import {connect} from "react-redux";
import {data} from "../../../Store/Actions/DataAction";
class WinnersTableIndex extends React.Component{
    constructor() {
        super()
        this.state= {
            style: {
                completed: 5,
                allLeagues:null,
                allDataLoaded:false,
                root: {
                    flexGrow: 1,
                    backgroundImage: "url(" + backgroundImage + ")",
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    width: '100%',
                    backgroundColor: "rgba(255, 190, 51, 1)",
                    height: '100%',
                    overflow: 'hidden',
                    backgroundBlendMode:'soft-light',
                    flex:1,
                    minHeight:'0',
                },
            }
        }
    }
    fetchData= async()=>{
        await axios.get(`users/data`)
            .then(res => {
                const {data}=res
                this.props.data(data)
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    fetchLeagues= async()=>{
        await axios.get(`/leaderboard/list_V3`)
            .then(res => {
                const {data}=res
                this.setState({
                    allLeagues:data
                })
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    async componentDidMount() {

        this.props.toggleBottomNavbar(true)
        await this.fetchData()
        await this.fetchLeagues()

    }
    componentDidUpdate() {
        if (!this.state.allDataLoaded)
            if (this.state.allLeagues && this.props.UserData.userData!=null){
                this.setState({
                    allDataLoaded:true
                })
            }
    }
    render(){
        let availableLeagues=[
            {
                id:'1189',
                name:'لیگ کلی',
                yourPlace:'385134',
                icon:Virus,
                placeholder:Holder,
                firstColor:'#183549',
                secondColor:'#183549',
                fontColor:'yellow',
                hasTwoValues:true,
                onClick:'/winners-table/main-league'
            },
        ]
        if (this.state.allLeagues) {
             availableLeagues=this.state.allLeagues.list.map(data=> {
                 return {
                     id:data.id,
                     name: data.name,
                     yourPlace: data.rank===''?'-':data.rank,
                     icon: data.backImg,
                     placeholder: Holder,
                     firstColor: data.back_color_1,
                     secondColor: data.back_color_2,
                     fontColor: data.title_text_color,
                     hasTwoValues: data.type!=='normal'?true:false,
                     currentOnClick: data.id,
                     prevID: data.type!=='normal' && data.prevID!==''?`${data.prevID}`:'',
                 }
             })
        }
            return(
                <Grid direction={"column"} item container style={this.state.style.root}>
                {
                    this.state.allDataLoaded &&
                                <Grid item sm={12} xs={12} direction={"column"} justify={'center'} container alignItems={"center"} style={{flex:'1',minHeight:'0'}}>
                                    <Grid item container>
                                        <Toolbar type='sideToolbar'/>
                                    </Grid>
                                    <Grid item container xs={12} justify={"center"} sm={12} className='scrollBar'
                                          style={{flex:'1',minHeight:'0',overflow:'auto',position:'relative'}}>
                                        <Grid item sm={12} xs={12} justify={'flex-start'} container style={{
                                        margin:'20px 0'}
                                        }>
                                            {
                                                availableLeagues.map(data=>{
                                                    return(
                                                        <Grid sm={6} xs={6} item justify={"center"} container style={{padding:'10px'}}>
                                                            <League data={data} />
                                                        </Grid>
                                                    )
                                                })
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>
                }
                {
                    !this.state.allLeagues &&
                    <Grid m={2} xs={2} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                          style={{position:'relative',
                              top:'50%',left:'50%',transform:'translate(-50%,-50%)'}}
                    >
                        <Grid item container justify={"center"} style={{position:'absolute',
                        }}>
                            <PicoLoader/>
                        </Grid>
                    </Grid>
                }
            </Grid>
        )
    }
}
const Winners=withRouter (WinnersTableIndex)
const mapStateToProps=state=>({
    UserData:state.UserData
})
export default connect(mapStateToProps,{data})(Winners)